
import { Link } from 'react-router-dom';
import './Details.css'
import { GoArrowRight } from "react-icons/go";
import sedan from '../../images/corola1.png'
import Suv from '../../components/gallery/Suv';
import Grand from '../../components/gallery/Grand';
import Mini from '../../components/gallery/Mini';
import Van from '../../components/gallery/Van';
import Coaster from '../../components/gallery/Coaster';
import { useRecoilState } from 'recoil';
import photoState from '../../components/atoms/photo.atom';
import suv from '../../images/suv3.png'
import grand from '../../images/grand.webp'
import h1 from '../../images/download.png'
import his from '../../images/b2.png'
import coaster from '../../images/coaster1.png'
import carState from '../../components/atoms/Car.atom';
import { useEffect } from 'react';
import photoTwoState from '../../components/atoms/PhotoTwo.atom';
import photoThreeState from '../../components/atoms/PhotoThree.atom';
import photoFourState from '../../components/atoms/PhotoFour.atom';
import photoFiveState from '../../components/atoms/PhotoFive.atom';
import photoSixState from '../../components/atoms/PhotoSix.atom';
import Sedan from '../../components/gallery/Sedan';

function Details() {
    const [show ,setShow] =useRecoilState(photoState)
    const [showTwo ,setShowTwo] =useRecoilState(photoTwoState)
    const [showThree ,setShowThree] =useRecoilState(photoThreeState)
    const [showFour ,setShowFour] =useRecoilState(photoFourState)
    const [showFive ,setShowFive] =useRecoilState(photoFiveState)
    const [showSix ,setShowSix] =useRecoilState(photoSixState)
    const [car ,setCar] =useRecoilState(carState)
    
    useEffect(()=>{
        localStorage.setItem('car',car)
    },[car])

const from =localStorage.getItem('pickupInp')
const to =localStorage.getItem('arrivalInp')
const goDate =localStorage.getItem('pickupDate')
const backDate =localStorage.getItem('returnDate')
const type =localStorage.getItem('type')
const price =localStorage.getItem('price')


const date = new Date(goDate);
const day = date.getDate();
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();
const formattedDate = `${day} ${month} ${year}`;

const reDate = new Date(backDate);
const days = reDate.getDate();
  const months = reDate.toLocaleString('en-US', { month: 'short' });
  const years = reDate.getFullYear();
const formattedDates = `${days} ${months} ${years}`;



  return (
    <>
        <div className="details">
            <div className="list">
                <div className="trip">
                    <div className="top">
                        <div className="one">
                            <div className="title pb-3">
                                <h1>Travel Limousine Results</h1>
                            </div>
                            <div className="cycle d-flex align-items-center">
                                <div className="location d-flex">
                                    <div className="from">
                                        <p className='m-0'>{from}, egypt</p>
                                    </div>
                                    <GoArrowRight className='arrow' />
                                    <div className="to">
                                        <p className='m-0'>{to}, egypt</p>
                                    </div>
                                </div>
                                <div className="date">
                                    <div className="first">
                                        <p className='m-0'>First Trip : {formattedDate}</p>
                                    </div>
                                    {
                                        type === 'Round' ? <div className="second ms-3">
                                            <p className='m-0'>Second Trip : {formattedDates}</p>
                                        </div> :null
                                    }
                                </div>
                                <Link to={'/'}>Change search</Link>
                            </div>
                        </div>
                        <div className="content">
                            <ul className="lists">
                                <div>
                                    <li className='type'>
                                        <div className="up">
                                            <div className="left">
                                                <div className="image">
                                                    <img src={sedan} alt="car" />
                                                </div>
                                                <div className="title">
                                                    <h3>Sedan</h3>
                                                    <span>Toyota, Elentra ,Kia & Similar Starting From 2021</span>
                                                </div>
                                            </div>
                                            <div className="right">
                                                <div className="price">
                                                    <span>{type} Trip Price</span>
                                                    <p className='m-0'><span>{price}</span> EGP</p>
                                                </div>
                                                <Link to={'/book'} onMouseEnter={()=>{setCar('sedan')}}><button className='book btn' type='button' >Book</button></Link>
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <ul className='d-flex p-0 m-0'>
                                                <li className='seats'>3 seats</li>
                                                <li className='bag'>1 Large Bag + 1 Small Bag</li>
                                            </ul>
                                            <div className="gallery" onClick={()=>{setShow(true)}}>
                                                Vehicle Gallery
                                            </div>
                                        </div>
                                    </li>
                                    <li className='type mt-4'>
                                        <div className="up">
                                            <div className="left">
                                                <div className="image suv">
                                                    <img src={suv} alt="car" className='suv' />
                                                </div>
                                                <div className="title">
                                                    <h3>SUV</h3>
                                                    <span>Tucson, Sportage ,MG zs & Similar Starting From 2021</span>
                                                </div>
                                            </div>
                                            <div className="right">
                                                <div className="price">
                                                    <span>{type} Trip Price</span>
                                                    <p className='m-0'><span>{+price+500}</span> EGP</p>
                                                </div>
                                                <Link to={'/book'} onMouseEnter={()=>{setCar('suv')
                                                    
                                                }}><button className='book btn'  type='button' >Book</button></Link>
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <ul className='d-flex p-0 m-0'>
                                                <li className='seats'>4 seats</li>
                                                <li className='bag'>3 Large Bag + 2 Small Bag</li>
                                            </ul>
                                            <div className="gallery" onClick={()=>{setShowTwo(true)}}>
                                                Vehicle Gallery
                                            </div>
                                        </div>
                                    </li>
                                    <li className='type mt-4'>
                                        <div className="up">
                                            <div className="left">
                                                <div className="image">
                                                    <img src={grand} alt="car" />
                                                </div>
                                                <div className="title">
                                                    <h3>SUV Grand</h3>
                                                    <span>Xpander, Glory ,Ortega & Similar Starting From 2021</span>
                                                </div>
                                            </div>
                                            <div className="right">
                                                <div className="price">
                                                    <span>{type} Trip Price</span>
                                                    <p className='m-0'><span>{+price+1000}</span> EGP</p>
                                                </div>
                                                <Link to={'/book'} onMouseEnter={()=>{setCar('grand')}}><button className='book btn' type='button' >Book</button></Link>
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <ul className='d-flex p-0 m-0'>
                                                <li className='seats'>6 seats</li>
                                                <li className='bag'>3 Large Bag + 2 Small Bag</li>
                                            </ul>
                                            <div className="gallery" onClick={()=>{setShowThree(true)}}>
                                                Vehicle Gallery
                                            </div>
                                        </div>
                                    </li>
                                    <li className='type mt-4'>
                                        <div className="up">
                                            <div className="left">
                                                <div className="image">
                                                    <img src={h1} alt="car" />
                                                </div>
                                                <div className="title">
                                                    <h3>Mini Van</h3>
                                                    <span>Hyundai H1 Starting From 2020</span>
                                                </div>
                                            </div>
                                            <div className="right">
                                                <div className="price">
                                                    <span>{type} Trip Price</span>
                                                    <p className='m-0'><span>{+price+1500}</span> EGP</p>
                                                </div>
                                                <Link to={'/book'} onMouseEnter={()=>{setCar('mini')}}><button className='book btn' type='button' >Book</button></Link>
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <ul className='d-flex p-0 m-0'>
                                                <li className='seats'>From 7 to 9 Seats</li>
                                                <li className='bag'>6 Large Bag</li>
                                            </ul>
                                            <div className="gallery" onClick={()=>{setShowFour(true)}}>
                                                Vehicle Gallery
                                            </div>
                                        </div>
                                    </li>
                                    <li className='type mt-4'>
                                        <div className="up">
                                            <div className="left">
                                                <div className="image">
                                                    <img src={his} alt="car" />
                                                </div>
                                                <div className="title">
                                                    <h3>Van</h3>
                                                    <span>Toyota HIAS Starting From 2022 </span>
                                                </div>
                                            </div>
                                            <div className="right">
                                                <div className="price">
                                                    <span>{type} Trip Price</span>
                                                    <p className='m-0'><span>{+price+2000}</span> EGP</p>
                                                </div>
                                                <Link to={'/book'} onMouseEnter={()=>{setCar('van')}}><button className='book btn' type='button' >Book</button></Link>
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <ul className='d-flex p-0 m-0'>
                                                <li className='seats'>13 seats</li>
                                                <li className='bag'>13 Large Bag</li>
                                            </ul>
                                            <div className="gallery" onClick={()=>{setShowFive(true)}}>
                                                Vehicle Gallery
                                            </div>
                                        </div>
                                    </li>
                                    <li className='type mt-4'>
                                        <div className="up">
                                            <div className="left">
                                                <div className="image">
                                                    <img src={coaster} alt="car" />
                                                </div>
                                                <div className="title">
                                                    <h3>Coaster</h3>
                                                    <span>Toyota Coaster Starting From 2020</span>
                                                </div>
                                            </div>
                                            <div className="right">
                                                <div className="price">
                                                    <span>{type} Trip Price</span>
                                                    <p className='m-0'><span>{+price+2500}</span> EGP</p>
                                                </div>
                                                <Link to={'/book'} onMouseEnter={()=>{setCar('coaster')}}><button className='book btn' type='button' >Book</button></Link>
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <ul className='d-flex p-0 m-0'>
                                                <li className='seats'>From 22 To 24 Seats</li>
                                                <li className='bag'>24 Large Bag</li>
                                            </ul>
                                            
                                            <div className="gallery" onClick={()=>{setShowSix(true)
                                                
                                            }}>
                                                Vehicle Gallery
                                            </div>
                                        </div>
                                    </li>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {
            show ?<Sedan/>:null
        }

        {
            showTwo ? <Suv/>:null
        }
        {
            showThree ? <Grand/>:null
        }
        {
            showFour ? <Mini/>:null
        }
        {
            showFive ? <Van/>:null
        }
        {
            showSix ? <Coaster/>:null
        }
        </div>
        
    </>
  )
}

export default Details